import { render } from "./slide-verify.vue?vue&type=template&id=68ce8ca3&scoped=true"
import script from "./slide-verify.vue?vue&type=script&lang=js"
export * from "./slide-verify.vue?vue&type=script&lang=js"

import "./slide-verify.vue?vue&type=style&index=0&id=68ce8ca3&scoped=true&lang=css"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ce8ca3"]])

export default __exports__